import React from "react";

import styles from "../../assets/css/modules/myprofile/crest-down-time-navigation.css";
import Store from "../../content/Store";



export const CrestDowntimeNotification = (props) => {


  return (

    <div

      className={styles.CrestDownTime}
    >
      {Store.CrestDowntimeNotication.International}
      {props.children}
    </div>

  );
};

export default CrestDowntimeNotification;